import { Component, EventEmitter, Input, Output } from "@angular/core";
import { MaterialModule } from "../../../modules/material.module";
import { ActivatedRoute, Router } from "@angular/router";
import { CommonModule } from "@angular/common";

@Component({
    selector: "app-nav-header",
    standalone: true,
    imports: [MaterialModule, CommonModule],
    templateUrl: "./nav-header.component.html",
    styleUrl: "./nav-header.component.scss",
})
export class NavHeaderComponent {
    @Input() pageTitle = "";
    @Input() routeTo = "";
    @Input() pageTitleCss = "text-white";
    @Output() back = new EventEmitter<void>();

    constructor(
        private router: Router,
        private route: ActivatedRoute,
    ) {}

    onBack(): void {
        this.back.emit();
        if (this.routeTo) {
            this.router.navigateByUrl(this.routeTo);
            return;
        }

        this.router.navigate([".."], { relativeTo: this.route });
    }
}
